unit PersonalDataType;
{

/* Initial */

}
interface

uses
  JS,
  AddressType, FunctionType, TitleType;

type
  TPersonalDataType = class
  private
    fPersonalDataKey: String;
    fTitle: TTitleType;
    fInitials: String;
    fFirstName: String;
    fPrefix: String;
    fLastName: String;
    fFullName: String;
    fAddress: TAddressType;
    fPhoneNumber: String;
    fEMailAddress: String;
    fLanguage: String;
    fFunction: TFunctionType;
  public
    property PersonalDataKey: String read fPersonalDataKey;
    property Title: TTitleType read fTitle;
    property Initials: String read fInitials;
    property FirstName: String read fFirstName;
    property Prefix: String read fPrefix;
    property LastName: String read fLastName;
    property FullName: String read fFullName;
    property Address: TAddressType read fAddress;
    property PhoneNumber: String read fPhoneNumber;
    property EMailAddress: String read fEMailAddress;
    property Language: String read fLanguage;
    property FunctionName: TFunctionType read fFunction;
    constructor Create(const String_JSON: String);
  end;

implementation

constructor TPersonalDataType.Create(const String_JSON: String);
var JSObject_Type: TJSObject;
begin
  if String_JSON <> 'null' then
  begin
    JSObject_Type := TJSJSON.parseObject(String_JSON);

    fPersonalDataKey := String(JSObject_Type['personalDataKey']);
    fTitle := TTitleType.Create(TJSJSON.stringify(JSObject_Type['title']));
    fInitials := String(JSObject_Type['initials']);
    fFirstName := String(JSObject_Type['firstName']);
    fPrefix := String(JSObject_Type['prefix']);
    fLastName := String(JSObject_Type['lastName']);
    fFullName := String(JSObject_Type['fullName']);
    fAddress := TAddressType.Create(TJSJSON.stringify(JSObject_Type['address']));
    fPhoneNumber := String(JSObject_Type['phoneNumber']);
    fEMailAddress := String(JSObject_Type['eMailAddress']);
    fLanguage := String(JSObject_Type['language']);
    fFunction := TFunctionType.Create(TJSJSON.stringify(JSObject_Type['function']));
  end;
end;

end.
